export { StandardPill } from './standard';

export type PillValue = string | number;

export interface BasePillProps {
  styleClasses: { [key: string]: string };
  variantName: string;
  className?: string;
  isTabbable?: boolean;
  onClick?: (value: PillValue | undefined, e?: React.SyntheticEvent) => void;
  onClose?: (value: PillValue | undefined, e?: React.SyntheticEvent) => void;
  selected?: boolean;
  value?: PillValue;
}

export type StandardPillProps = Omit<BasePillProps, 'styleClasses' | 'variantName'>
